import { ITile } from "../../store/slices/environmentSlice";
import { store } from "../../store/store";

import { CURRENT_BOOKINGS, PREVIOUS_BOOKINGS, SEARCH } from "./routes";

const getTileBackground = (
  tileKey: "start" | "current" | "previous",
): string => {
  const state = store.getState().environment;

  switch (tileKey) {
    case "start":
      return state.start_booking_section_background;
    case "current":
      return state.current_bookings_section_background;
    case "previous":
      return state.previous_bookings_section_background;
    default:
      return "";
  }
};

const TILES: ITile[] = [
  {
    link_url: `/#${SEARCH}`,
    title: () => store.getState().environment.start_booking_title,
    description_text: () =>
      store.getState().environment.start_booking_description,
    background_image: () => getTileBackground("start"),
    background_color: "primary",
    target: "_self",
  },
  {
    link_url: `/#${CURRENT_BOOKINGS}`,
    title: () => store.getState().environment.current_bookings_title,
    description_text: () =>
      store.getState().environment.current_bookings_description,
    background_image: () => getTileBackground("current"),
    background_color: "primary",
    target: "_self",
  },
  {
    link_url: `/#${PREVIOUS_BOOKINGS}`,
    title: () => store.getState().environment.previous_bookings_title,
    description_text: () =>
      store.getState().environment.previous_bookings_description,
    background_image: () => getTileBackground("previous"),
    background_color: "primary",
    target: "_self",
  },
];

const AGENT_HOME = { TILES };

export default AGENT_HOME;
